export const showHideController = {
  groupFare: false,
};
